import React, { useEffect, useRef, useState } from "react";
// This bundle includes both the Player and the UI logic together
import shaka from 'shaka-player/dist/shaka-player.ui.js';
import 'shaka-player/dist/controls.css';
import {  useNavigate } from "react-router";
import { MdFullscreen, MdFullscreenExit, MdPause, MdPictureInPicture, MdPlayArrow, MdVolumeDown, MdVolumeMute, MdVolumeUp } from "react-icons/md";
import SVGLOGO from "../__DEV/Old Design/OldComponents/logo";
shaka.polyfill.installAll();
const VideoPlayer = ({src,clearKeys}) => {

const containerRef = useRef(null);
const videoRef = useRef(null);
const playerRef = useRef(null);
const [isPlaying, setIsPlaying] = useState(false);
const [currentTime, setCurrentTime] = useState(0);
const [duration, setDuration] = useState(0);
const [bufferedAmount, setBufferedAmount] = useState(0);

const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const navigate = useNavigate();

useEffect(() => {
   
    const initPlayer = async () => {
      // 1. If a player exists, destroy it before starting a new one
      if (playerRef.current) {
        await playerRef.current.destroy();
      }

      // 2. Create the player
      const player = new shaka.Player();
      playerRef.current = player;
   await player.attach(videoRef.current);
      // 3. Configure DRM
      player.configure({
        drm: { clearKeys }
      });

      try {
        // 4. Load the s ource
        
          await player.load(src);
          console.log("The video has now been loaded!");
       
      } catch (e) {
      
          console.error('Shaka Error:', e);
       
      }
    };
   
    if (videoRef.current) {
      initPlayer();
    }
  

  }, [src,clearKeys]); 
 
       
 
 useEffect(() => {
     const video = videoRef.current;
     if (!video) return;
 
     // 2. Define handler functions
       const handleProgress = () => {
      if (video.buffered.length > 0) {
        // Get the end time of the last buffered range
        const bufferedEnd = video.buffered.end(video.buffered.length - 1);
        // Convert to percentage
        const percent = (bufferedEnd / video.duration) * 100;
        setBufferedAmount(percent);
      }
    };
     const handlePlay = () => setIsPlaying(true);
     const handlePause = () => setIsPlaying(false);
     const updateTime = () => setCurrentTime(video.currentTime);
     const updateDuration = () => setDuration(video.duration);
 
     // 3. Attach listeners for real-time updates
     video.addEventListener('play', handlePlay);
     video.addEventListener('pause', handlePause);
     video.addEventListener('playing', handlePlay); // Handles resuming after buffering
    
     video.addEventListener('progress', handleProgress);
     video.addEventListener('timeupdate', updateTime);
     video.addEventListener('loadedmetadata', updateDuration);
 
     // Cleanup listeners when component unmounts
     return () => {
       video.removeEventListener('progress', handleProgress);
       video.removeEventListener('timeupdate', updateTime);
       video.removeEventListener('loadedmetadata', updateDuration);
       video.removeEventListener('play', handlePlay);
       video.removeEventListener('pause', handlePause);
       video.removeEventListener('playing', handlePlay);
     };
   }, []);
 
 

 
  const togglePlay = () => {
 if (videoRef.current.paused) videoRef.current.play();
     else videoRef.current.pause();
   };
 
 const [isFullScreen, setIsFullScreen] = useState(false);
 useEffect(() => {
     const handleFsChange = () => {
       setIsFullScreen(!!document.fullscreenElement);
     };
     document.addEventListener('fullscreenchange', handleFsChange);
     return () => document.removeEventListener('fullscreenchange', handleFsChange);
   }, []);
 const toggleFullScreen = () => {
     if (!document.fullscreenElement) {
       // Request full screen on the CONTAINER, not the video
       containerRef.current.requestFullscreen().catch((err) => {
         console.error(`Error attempting to enable full-screen: ${err.message}`);
       });
     } else {
       document.exitFullscreen();
     }
   };
 
 const timerRef = useRef(null);
 const [showControls, setShowControls] = useState(true);
 // Function to start/reset the auto-hide timer
   const startTimer = () => {
     if (timerRef.current) clearTimeout(timerRef.current);
     
     timerRef.current = setTimeout(() => {
       if (!videoRef.current?.paused) {
         setShowControls(false);
       }
     }, 3000);
   };
 
   const handleInteraction = () => {
     setShowControls(true);
     startTimer();
   };
 
   // Stop the timer so controls stay visible while hovering the overlay
   const handleMouseEnterOverlay = () => {
     if (timerRef.current) clearTimeout(timerRef.current);
     setShowControls(true);
   };
 
   // Restart the timer when leaving the overlay
   const handleMouseLeaveOverlay = () => {
     startTimer();
   };
 
   useEffect(() => {
     startTimer();
     return () => { if (timerRef.current) clearTimeout(timerRef.current); };
   }, []);       
   
   
const [isPipAvailable, setIsPipAvailable] = useState(false);

  useEffect(() => {
    // Check if PiP is supported and enabled in the browser
    const checkPipSupport = () => {
      if (document.pictureInPictureEnabled && videoRef.current) {
        setIsPipAvailable(true);
      }
    };

    checkPipSupport();
  }, []);

  const togglePip = async () => {
    try {
      if (document.pictureInPictureElement) {
        await document.exitPictureInPicture();
      } else if (videoRef.current) {
        await videoRef.current.requestPictureInPicture();
      }
    } catch (error) {
      console.error("PiP Error:", error);
    }
  };



useEffect(() => {
  const handleKeyDown = (event) => {
    // 1. Check if the user is typing in an input or textarea (like a search bar)
    // We don't want to pause the video while they are typing!
    const isTyping = document.activeElement.tagName === 'INPUT' || 
                     document.activeElement.tagName === 'TEXTAREA';

    if (isTyping) return;

    // 2. Detect 'Enter' or 'Space' (Standard video shortcuts)
    if ( event.code === 'Space') {
      event.preventDefault(); // Prevent page scrolling or accidental button clicks
      
      if (videoRef.current) {
        if (videoRef.current.paused) {
          videoRef.current.play();
        } else {
          videoRef.current.pause();
        }
      }
    }
  };

  // Attach to window so it works even if the video isn't focused
  window.addEventListener('keydown', handleKeyDown);

  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, []);


  //  Live Scrubbing: Update the frame as they drag
  const handleScrub = (e) => {
    const time = Number(e.target.value);
    setCurrentTime(time);
    
    if (videoRef.current) {
      videoRef.current.currentTime = time;
    }
  };
// Auto-Play Logic: Start playing when they let go
  const handleScrubEnd = () => {
    if (videoRef.current && videoRef.current.paused) {
      videoRef.current.play().catch(error => {
        // Browsers might block auto-play if no user gesture was detected
        console.log("Auto-play blocked or failed:", error);
      });
    }
  };

 const playedPercent = (currentTime / duration) * 100 || 0;






  const toggleVideoClick = () => {
    if(!isPlaying) return;

    if(showControls) setShowControls(false);
    else handleInteraction();
  };





const [volume, setVolume] = useState(1);
  const [isMuted, setIsMuted] = useState(false);
  const [prevVolume, setPrevVolume] = useState(1);

  // Sync state with video element
  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    videoRef.current.volume = newVolume;
    setIsMuted(newVolume === 0);
  };

  const toggleMute = () => {
    if (isMuted) {
      // Unmute and restore previous volume
      const restoreVol = prevVolume > 0 ? prevVolume : 1;
      videoRef.current.volume = restoreVol;
      setVolume(restoreVol);
      setIsMuted(false);
    } else {
      // Mute and save current volume to restore later
      setPrevVolume(volume);
      videoRef.current.volume = 0;
      setVolume(0);
      setIsMuted(true);
    }
  };


useEffect(() => {
  const handleKeyDown = (event) => {
    // 1. Safety check: Don't trigger if user is typing in a search bar or notes
    const isTyping = document.activeElement.tagName === 'INPUT' || 
                     document.activeElement.tagName === 'TEXTAREA';
    if (isTyping) return;

    const video = videoRef.current;
    if (!video) return;

    switch (event.key) {
      case 'ArrowUp':
        event.preventDefault(); // Prevent page scrolling
        // Math.min ensures we don't go above 1.0 (100%)
        const newVolUp = Math.min(video.volume + 0.1, 1);
        video.volume = newVolUp;
        setVolume(newVolUp); // Sync your UI state
        setIsMuted(newVolUp === 0);
         handleInteraction(); // Show UI so user sees the volume bar changing
        break;

      case 'ArrowDown':
        event.preventDefault();
        // Math.max ensures we don't go below 0 (0%)
        const newVolDown = Math.max(video.volume - 0.1, 0);
        video.volume = newVolDown;
        setVolume(newVolDown);
        setIsMuted(newVolDown === 0);
        handleInteraction();
        break;

      default:
        break;
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
}, [volume]); // Include












const [touchStart, setTouchStart] = useState(null);

const handleTouchStart = (e) => {
    // Record the Y position where the finger first touches the screen
    setTouchStart(e.targetTouches[0].clientY);
  };

  const handleTouchMove = (e) => {
    if (!touchStart || !document.fullscreenElement) return;

    const touchEnd = e.targetTouches[0].clientY;
    const distance = touchEnd - touchStart;

    // If the swipe is downward and longer than 100 pixels
    if (distance > 200) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        setTouchStart(null); // Reset after exiting
      }
    }
  };




  return (
   <div 
  ref={containerRef} 
  onTouchStart={handleTouchStart}
   onTouchMove={handleTouchMove}
  className="relative group bg-black w-full flex flex-col select-none overflow-hidden "
  style={{ cursor: showControls ? 'default' : 'none'  }}
  >

   
 


   <video 
   className={` w-full m-auto max-h-screen `}
   autoPlay
   ref={videoRef} 
   /*controls */
   playsInline
    webkit-playsinline="true"
   />


{/*  CENTER PLAY/PAUSE BUTTON */}
      <div 
       onMouseMove={handleInteraction}
 //   onTouchStart={handleInteraction}
      onClick={toggleVideoClick}
      onDoubleClick={toggleFullScreen}
        className={`absolute inset-0 flex items-center justify-center `}
      >
        <button 
          onClick={(e) => {
            e.stopPropagation(); // Prevent double triggering from video click
            togglePlay();
          }}
          className={`pointer-events-auto  transition-all duration-500 ${
          isPlaying?
          showControls  ? 'opacity-100' : 'opacity-0'
          : 'opacity-100'
        } 
        bg-black/40 hover:bg-black/60 text-white  p-3 md:p-5 lg:p-6 
        rounded-full backdrop-blur-sm border border-white/20 
         active:scale-90`}
        >
            {isPlaying 
           ?<MdPause   className='hover:fill-[#dbdbdb]' color='#ffffff' size={25} />
           :<MdPlayArrow className='hover:fill-[#dbdbdb]' color='#ffffff' size={25} />
             }
        </button>
      </div>




  {/* Top Custom Overlay Controls */}
      <div 
      onMouseEnter={handleMouseEnterOverlay}
      onMouseLeave={handleMouseLeaveOverlay}
      className={`absolute flex justify-between top-0 w-full left-0 right-0 px-4  py-2
     ${/*" bg-gradient-to-t from-black/80 to-transparent"*/''}  transition-all duration-500 ease-in-out
   ${
      isPlaying 
       ? `${ showControls ? "opacity-100 translate-y-0 " : "opacity-0 -translate-y-full"} `  
       : 'opacity-100 translate-y-0' 
     
   }`}>
        
        

         <button className="  py-1 px-2 md:py-2 md:px-4    rounded  bg-[#2e8a57]  text-white " onClick={()=>{ 
          if(isFullScreen) toggleFullScreen();
          else navigate(-1);
          }} >{isFullScreen ? 'خروج' :'رجوع'}</button>
  

 <button 
         // onClick={togglePlay}
          className="text-[#2e8a57] font-bold"
        >
          {/* You can use HeroIcons or Lucide-React here */}
          <SVGLOGO className={`h-[35px] md:h-[50px]  `} height={'50px'} fill={'#2e8a57'} />
        </button>



      </div>


<div 
onMouseEnter={handleMouseEnterOverlay}
onMouseLeave={handleMouseLeaveOverlay}
className={`absolute bottom-2 left-0 right-0 z-20 px-4 py-1
bg-black/60 backdrop-blur-sm  rounded-lg mx-1 transition-all duration-500 ease-in-out
${
      isPlaying 
       ? `${ showControls ? "opacity-100 translate-y-0 " : "opacity-0 translate-y-full"} `  
       : 'opacity-100 translate-y-0' 
     
    }`}>



    </div>



  {/* Bottom Custom Overlay Controls */}
<div 
onMouseEnter={handleMouseEnterOverlay}
onMouseLeave={handleMouseLeaveOverlay}
className={`absolute bottom-1 left-0 right-0 z-20 px-4 py-1
bg-black/60 backdrop-blur-sm  rounded-lg mx-1 transition-all duration-500 ease-in-out
${
      isPlaying 
       ? `${ showControls ? "opacity-100 translate-y-0 " : "opacity-0 translate-y-full"} `  
       : 'opacity-100 translate-y-0' 
     
    }`}>
      <div className='flex  gap-3'>
           <div className="font-sans text-white text-sm my-auto">
              {formatTime(currentTime)}/{formatTime(duration)}
            </div>

      {/* --- PROGRESS BAR SECTION --- */}
      <div className="my-auto relative w-full h-3 mt-[5px] flex items-center ">
        
        {/* Layer 1: Background (The whole bar) */}
        <div className="absolute w-full h-1.5 bg-gray-700 rounded-full" />

        {/* Layer 2: Buffered (The "Downloaded" part - Light Gray/Blue) */}
        <div 
          className="absolute h-1.5 bg-white/30 rounded-full transition-all duration-300 ease-out"
          style={{ width: `${bufferedAmount}%` }}
        />

        {/* Layer 3: Played (The current position - Your brand Green) */}
        <div 
          className="absolute h-1.5 bg-[#2e8a57] rounded-full z-10"
          style={{ width: `${playedPercent}%` }}
        />

        {/* Layer 4: The Actual Range Input (Invisible but handles clicks) */}
        {/* We make it opacity-0 so we can see our custom bars underneath */}
        <input
          type="range"
          min={0}
          max={duration || 0}
          value={currentTime}
          step="0.1" // Higher precision for smoother scrubbing
          onChange={handleScrub}
          onMouseUp={handleScrubEnd}   // Desktop: Trigger play on release
          onTouchEnd={handleScrubEnd}  // Mobile: Trigger play on release
          className="absolute w-full h-full opacity-0 z-20 cursor-pointer appearance-none"
        />
        
        {/* Layer 5: Custom Thumb (Optional - The moving circle) */}
        <div 
          className="absolute w-4 h-4 bg-white border-2 border-[#2e8a57] rounded-full z-30 pointer-events-none shadow-md"
          style={{ right: `calc(${playedPercent}% - 8px)` }}
        />
      </div>
        </div>
        {/* Progress Bar */}
       {/* <input
          type="range"
          min="0"
          max={duration || 0}
          value={currentTime}
          onChange={handleSeek}
          className="w-full h-1 mb-2 accent-[#2e8a57] cursor-pointer"
        />*/}

        <div className="flex items-center mt-3 justify-between ">
          <div className="flex items-center gap-4">
            <button onClick={togglePlay} className="hover:text-[#2e8a57] transition-colors">
              {isPlaying 
           ?<MdPause   className='hover:fill-[#dbdbdb]' color='#ffffff' size={25} />
           :<MdPlayArrow className='hover:fill-[#dbdbdb]' color='#ffffff' size={25} />
             }
            </button>
            {/* VOLUME SECTION */}
        <div className="flex items-center group/volume">
          <button 
            onClick={toggleMute}
            className="relative text-white hover:text-[#2e8a57] transition-colors  "
          >
            {isMuted || volume === 0 ? (
              /* Mute Icon */
              <MdVolumeMute className='hover:fill-[#dbdbdb] transition-colors' color='#ffffff' size={25} />
            ) : (
              
              volume > 0.7 
              /* High Volume Icon */
              ? <MdVolumeUp className='hover:fill-[#dbdbdb] transition-colors' color='#ffffff' size={25} />
            :<MdVolumeDown className='hover:fill-[#dbdbdb] transition-colors' color='#ffffff' size={25} />
            )}
          </button>

          {/* Volume Slider - Expand on hover of the volume section */}
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={volume}
            onChange={handleVolumeChange}
            className=" accent-[#2e8a57] h-1.5 cursor-pointer  bg-white/20 rounded-full"
          />
        </div>
          
          </div>
          <div className="flex items-center gap-4">
{/* PiP Button - Only show if supported */}
        {isPipAvailable && (
          <button 
            onClick={togglePip}
            className=" "
            title="Picture in Picture"
          >
           <MdPictureInPicture className='hover:fill-[#dbdbdb] transition-colors' color='#ffffff' size={25}  />
          </button>
        )}
          <button  title={isFullScreen ? "Exit Full Screen" : "Full Screen"} onClick={toggleFullScreen} className="">
          {isFullScreen 
           ?<MdFullscreenExit  className='hover:fill-[#dbdbdb] transition-colors' color='#ffffff' size={25} />
           :<MdFullscreen className='hover:fill-[#dbdbdb]' color='#ffffff' size={25} />
             }
          </button>
          </div>

        </div>
      </div>

  </div>
 )
   
   
};

export default VideoPlayer;
